/**
 * @param {object} props
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {React.ReactNode} [props.action]
 */
export default function EmptyState({ title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center animate-fade-in">
      <div className="w-20 h-20 rounded-full bg-[#002882]/10 flex items-center justify-center mb-5">
        <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 24 24" fill="none" stroke="#002882" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <circle cx={12} cy={12} r={10}/>
          <path d="M8 12h8"/>
        </svg>
      </div>
      <h3 className="text-lg font-semibold mb-2 text-gray-900">{title}</h3>
      {description && <p className="text-sm text-gray-500 max-w-md leading-relaxed mb-5">{description}</p>}
      {action}
    </div>
  );
}